import { hookUtils } from '@pukka/common/utils';
import { twMerge } from 'tailwind-merge';

import styles from './container.module.css';

interface ContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly children: React.ReactNode;
}

function ContentContainer({ className, ...props }: ContentContainerProps) {
  const isMobile = hookUtils.useIsMobile();

  return (
    <div {...props} className={twMerge(isMobile ? styles.contentMobile : styles.content, 'relative h-full transition-all', className)} />
  );
}

export { ContentContainer };
